<template>
  <div class="assessmentInfos">
    <assessmentInfosList></assessmentInfosList>
  </div>
</template>

<script>
import assessmentInfosList from './assessmentInfosList.vue'

export default {
  components: {
    assessmentInfosList
  }
}
</script>
<style scoped>
.assessmentInfos {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/assessmentInfos/assessmentInfos.vue